import React, { createContext, useContext, useState, useEffect } from 'react';
import ContactModal from '../components/ContactModal';
import BookingModal from '../components/BookingModalNew';

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [hasContactSubmitted, setHasContactSubmitted] = useState(false);

  useEffect(() => {
    const submitted = localStorage.getItem('contact_submitted') === 'true';
    setHasContactSubmitted(submitted);
  }, []);

  const openBooking = () => {
    setIsBookingOpen(true);
    localStorage.setItem('booking_submitted', 'true');
    localStorage.setItem('pricing_unlocked', 'true');
  };
  
  const closeBooking = () => {
    setIsBookingOpen(false);
  };
  
  const openContact = () => setIsContactOpen(true);
  const closeContact = () => {
    setIsContactOpen(false);
    const submitted = localStorage.getItem('contact_submitted') === 'true';
    setHasContactSubmitted(submitted);
  };
  
  const onContactSubmitSuccess = () => {
    setHasContactSubmitted(true);
  };

  return (
    <BookingContext.Provider value={{ 
      isBookingOpen, openBooking, closeBooking,
      isContactOpen, openContact, closeContact,
      hasContactSubmitted
    }}>
      {children}
      <BookingModal isOpen={isBookingOpen} onClose={closeBooking} />
      <ContactModal isOpen={isContactOpen} onClose={closeContact} onSubmitSuccess={onContactSubmitSuccess} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};
